import React from 'react'
import { Grid, GridColumn, GridRow } from 'semantic-ui-react'
import AddressFields from '../common/fieldgroups/AddressFields'
import GroupFields from '../common/fieldgroups/GroupFields'
import useScrollToTop from '../../../hooks/useScrollToTop'
import RegisteredFormField from '../../common/RegisteredFormField'

export default function Employer () {

  return useScrollToTop(
    <Grid container stackable>
      <GridRow>
        <GridColumn width={16}>
          <h3>Employer Information</h3>
        </GridColumn>
      </GridRow>
      <GridRow className='horizontally-divided'>
        <GroupFields path='segments.employer.fields' />
        <AddressFields rootPath='segments.employer.fields' />
        <GridColumn className='u-mY0' width={5}>
          <RegisteredFormField
            id='employerTelephone'
            path='segments.employer.fields.telephone'
            label='Telephone (optional)'
          />
        </GridColumn>
      </GridRow>
    </Grid>
  )
}